import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { useStatusReportContext } from '../../../statusReportContext'

const useStyles = makeStyles((theme) => ({
  panelTrigger: {
    '&:hover': {
      cursor: 'pointer'
    }
  }
}))

function PanelTriggerBoardLayout ({ className, item, children, disabled }) {
  const classes = useStyles()
  const { setSelectedStatusReportItemId, selectedStatusReportItemId } = useStatusReportContext()

  const handlePanelTrigger = useCallback((e) => {
    if (disabled) return null

    if (selectedStatusReportItemId !== item.statusReportItemId) {
      e.stopPropagation()
    }
    setSelectedStatusReportItemId(item.statusReportItemId)
  }, [disabled, item.statusReportItemId, selectedStatusReportItemId, setSelectedStatusReportItemId])

  return (
    <div
      className={clsx(className, classes.panelTrigger)}
      role='button'
      onClick={handlePanelTrigger}
    >
      {children}
    </div>
  )
}

PanelTriggerBoardLayout.propTypes = {
  className: PropTypes.string,
  item: PropTypes.any,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired
}

export default React.memo(PanelTriggerBoardLayout)
